export const RECEIVE_USER_INFO = 'RECEIVE_USER_INFO'
export const RECEIVE_ORDER_LIST = 'RECEIVE_ORDER_LIST'
export const APPEND_ORDER_LIST = 'APPEND_ORDER_LIST'
export const RECEIVE_SCENE_ORDER_LIST = 'RECEIVE_SCENE_ORDER_LIST'
export const APPEND_SCENE_ORDER_LIST = 'APPEND_SCENE_ORDER_LIST'
export const SET_ACCOUNT_ORDERS_SORT = 'SET_ACCOUNT_ORDERS_SORT'
export const SET_ACCOUNT_ORDERS_CATEGORY = 'SET_ACCOUNT_ORDERS_CATEGORY'
export const SET_ACCOUNT_ORDERS_PAGEINDEX = 'SET_ACCOUNT_ORDERS_PAGEINDEX'
export const SET_ACCOUNT_ORDERS_MAXPAGESIZE = 'SET_ACCOUNT_ORDERS_MAXPAGESIZE'
export const SET_ACCOUNT_COMMISSION_TYPE_KEYS = 'SET_ACCOUNT_COMMISSION_TYPE_KEYS'
export const SET_ACCOUNT_COMMISSION_TYPE = 'SET_ACCOUNT_COMMISSION_TYPE'
export const SET_ACCOUNT_COMMISSION_DATESCOPE = 'SET_ACCOUNT_COMMISSION_DATESCOPE'
export const RECEIVE_ACCOUNT_COMMISSION_LIST = 'RECEIVE_ACCOUNT_COMMISSION_LIST'
export const APPEND_ACCOUNT_COMMISSION_LIST = 'APPEND_ACCOUNT_COMMISSION_LIST'
export const SET_ACCOUNT_COMMISSION_MAXPAGESIZE = 'SET_ACCOUNT_COMMISSION_MAXPAGESIZE'
export const SET_ACCOUNT_COMMISSION_PAGEINDEX = 'SET_ACCOUNT_COMMISSION_PAGEINDEX'
export const RECEIVE_ACCOUNT_COMMISSION_TOTALMONEY = 'RECEIVE_ACCOUNT_COMMISSION_TOTALMONEY'
export const RECEIVE_USER_MESSAGECODE = 'RECEIVE_USER_MESSAGECODE'
export const RECEIVE_USER_LOGIN = 'RECEIVE_USER_LOGIN'

export const RECEIVE_ACTIVITY_LIST = 'RECEIVE_ACTIVITY_LIST'
export const RECEIVE_ACTIVITY_DETAIL = 'RECEIVE_ACTIVITY_DETAIL'
export const SET_ACTIVITY_MAXPAGESIZE = 'SET_ACTIVITY_MAXPAGESIZE'
export const SET_ACTIVITY_PAGEINDEX = 'SET_ACTIVITY_PAGEINDEX'
export const APPEND_ACTIVITY_LIST = 'APPEND_ACTIVITY_LIST'

export const RECEIVE_PROVINCE_LIST = 'RECEIVE_PROVINCE_LIST'
export const RECEIVE_PROVINCE_CITY_LIST = 'RECEIVE_PROVINCE_CITY_LIST'
export const CLEARE_CITY_LIST = 'CLEARE_CITY_LIST'
export const CHANGE_USER_CITY = 'CHANGE_CITY'
export const INIT_BASE_INFO = 'INIT_BASE_INFO'
export const SET_HOME_BANNER = 'SET_HOME_BANNER'
export const RECEIVE_REWARD_LIST = 'RECEIVE_REWARD_LIST'

export const RECEIVE_PRODUCT_LIST = 'RECEIVE_PRODUCT_LIST'
export const RECEIVE_PRODUCT_DETAIL = 'RECEIVE_PRODUCT_DETAIL'
export const SET_PRODUCT_MAXPAGESIZE = 'SET_PRODUCT_MAXPAGESIZE'
export const SET_PRODUCT_PAGEINDEX = 'SET_PRODUCT_PAGEINDEX'
export const APPEND_PRODUCT_LIST = 'APPEND_PRODUCT_LIST'

export const RECEIVE_CERTIFICATE_LIST = 'RECEIVE_CERTIFICATE_LIST'
export const RECEIVE_CERTIFICATE_IMAGES = 'RECEIVE_CERTIFICATE_IMAGES'

export const RECEIVE_WITHDRAW_LIST = 'RECEIVE_WITHDRAW_LIST'
export const APPEND_WITHDRAW_LIST = 'APPEND_WITHDRAW_LIST'
export const SET_ACCOUNT_WITHDRAW_MAXPAGESIZE = 'SET_ACCOUNT_WITHDRAW_MAXPAGESIZE'
export const SET_ACCOUNT_WITHDRAW_PAGEINDEX = 'SET_ACCOUNT_WITHDRAW_PAGEINDEX'

export const RECEIVE_PAYMONEY_LIST = 'RECEIVE_PAYMONEY_LIST'
export const APPEND_PAYMONEY_LIST = 'APPEND_PAYMONEY_LIST'
export const SET_ACCOUNT_PAYMONEY_MAXPAGESIZE = 'SET_ACCOUNT_PAYMONEY_MAXPAGESIZE'
export const SET_ACCOUNT_PAYMONEY_PAGEINDEX = 'SET_ACCOUNT_PAYMONEY_PAGEINDEX'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js